
import React, { Suspense, lazy, useRef, useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
const  Privacypolicy = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
        <div className="ivo-text-box ivo-section text-center">
        <h2 className="ivo-heading">
            <span className="color_title">Privacy </span> Policy
        </h2>
    </div>

        <section className="ivo-section page-content">
            <div className="container">
                <div className="text-box">
                    <h5>1. Introduction</h5>
                    <p>
                        At IVOIRE Tradings, we value the privacy and security of our users. This Privacy Policy outlines how
                        we collect, use, disclose, and protect your personal information when you use our website and
                        services. By accessing or using our platform, you consent to the practices described in this policy.
                    </p>
                    <h5>2. Information We Collect</h5>
                    <p>a. <b>Personal Information:</b> When you create an account or use our services, we may collect
                        personal
                        information such as your name, email address, contact information, and any other information you
                        provide voluntarily.</p>
                    <p> b. <b>Usage Data:</b> We may collect non-personal information about your interactions with our
                        platform,
                        including your IP address, browser type, referring/exit pages, and the dates/times of your visits.
                        We may also use cookies and similar technologies to enhance your user experience.</p>



                    <h5>3. How We Use Your Information</h5>
                    <p>a. <b>Provide and Improve Services:</b> We use your information to deliver and personalize our
                        services,
                        process transactions, and respond to your inquiries. We may also use your information to analyze and
                        improve the functionality and performance of our platform.</p>
                    <p>b. <b>Communication:</b> We may use your contact information to send you important updates,
                        notifications,
                        and promotional materials related to our services. You have the option to unsubscribe from marketing
                        communications at any time.</p>
                    <p>c. <b>Security and Fraud Prevention:</b> We utilize your information to ensure the security of our
                        platform,
                        protect against fraudulent activities, and comply with legal obligations.</p>

                    <h5>4. Information Sharing and Disclosure</h5>
                    <p>
                        a. <b>Third-Party Service Providers:</b> We may engage trusted third-party service providers to
                        assist us in delivering our services. These providers have access to your personal information only
                        to perform specific tasks on our behalf and are obligated to protect your data.
                    </p>
                    <p>b. <b>Legal Requirements:</b> We may disclose your personal information if required to do so by law,
                        court order, or
                        governmental authority.</p>
                    <p>c. <b>Business Transfers:</b> In the event of a merger, acquisition, or sale of all or a portion of
                        our
                        business, your personal information may be transferred as part of the transaction. We will notify
                        you of any such change and provide you with the option to opt out if applicable.</p>
                    <h5>5. Data Security</h5>
                    <p>We implement industry-standard security measures to protect your personal information from
                        unauthorized access, disclosure, alteration, or destruction. However, no data transmission or
                        storage method can be guaranteed as 100% secure. We strive to protect your information, but we
                        cannot ensure absolute security.
                    </p>


                    <h5>6. Your Privacy Choices</h5>
                    <p>a. <b> Account Information:</b> You have the right to access, update, and correct your personal
                        information through your account settings. If you wish to delete your account, please contact us
                        using the information provided below.
                    </p>
                    <p>b. <b>Cookies and Tracking Technologies:</b> Most web browsers are set to accept cookies by default.
                        You can
                        modify your browser settings to block or delete cookies, but this may affect the functionality of
                        our platform.
                    </p>



                    <h5>7. Children's Privacy</h5>
                    <p>Our services are not directed to individuals under the age of 18. We do not knowingly collect or
                        solicit personal information from anyone under 18. If we become aware that we have collected
                        personal information from a child under 18, we will take steps to delete it promptly.
                    </p>
                    <h5>8. Changes to this Privacy Policy</h5>
                    <p>We may update this Privacy Policy from time to time. We will notify you of any significant changes by
                        posting the revised policy on our website. We encourage you to review this policy periodically.
                    </p>
                    <h5>9. Contact Us</h5>
                    <p>If you have any questions, concerns, or requests regarding this Privacy Policy, please contact us at info@ivoiretrading.com
                      
                    </p>
                    <p>
                        By using our platform, you acknowledge that you have read and understood this Privacy Policy and agree to the collection, use, and disclosure of your personal information as outlined herein.
                        </p>

                </div>
            </div>

        </section>
    </>
    );
}

export default Privacypolicy;
